'use client'

import { useEffect, useState } from 'react'
import { Moon, Sun } from 'lucide-react'
import styles from './landing.module.css'

const themeStorageKey = 'turno-landing-theme'

export function LandingThemeToggle() {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    let theme = 'light'

    try {
      theme = window.localStorage.getItem(themeStorageKey) === 'dark' ? 'dark' : 'light'
    } catch {
      // The light theme remains available when storage is unavailable.
    }

    document.querySelector('[data-landing-theme-root]')?.setAttribute('data-theme', theme)
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', theme === 'dark' ? '#0d0d12' : '#fbfaf7')
    setIsDark(theme === 'dark')
  }, [])

  const toggleTheme = () => {
    const nextTheme = isDark ? 'light' : 'dark'
    document.querySelector('[data-landing-theme-root]')?.setAttribute('data-theme', nextTheme)
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', nextTheme === 'dark' ? '#0d0d12' : '#fbfaf7')

    try {
      window.localStorage.setItem(themeStorageKey, nextTheme)
    } catch {
      // Keep the current-page toggle usable when storage is unavailable.
    }

    setIsDark(nextTheme === 'dark')
  }

  return (
    <button
      className={styles.themeToggle}
      type="button"
      aria-label="Tema oscuro"
      aria-pressed={isDark}
      title={`Cambiar al tema ${isDark ? 'claro' : 'oscuro'}`}
      onClick={toggleTheme}
    >
      <span className={styles.themeTrack} aria-hidden="true">
        <span className={styles.themeThumb}>
          {isDark ? <Sun size={13} /> : <Moon size={13} />}
        </span>
      </span>
      <span className={styles.themeToggleLabel}>{isDark ? 'Claro' : 'Oscuro'}</span>
    </button>
  )
}
